import axios from "@/libs/api.request";

export const getPackage = (params) => {
  return axios.request({
    url: "/warehouse/cargo",
    method: "get",
    params,
  });
};

export const add = (data) => {
  return axios.request({
    url: "/warehouse/cargo",
    method: "post",
    data,
  });
};

export const getDetails = (id) => {
  return axios.request({
    url: `/warehouse/cargo/cargoDetails/${id}`,
    method: "get",
  });
};

export const postCargoOrder = (data) => {
  return axios.request({
    url: `/warehouse/cargo/checkCargoOrder`,
    method: "post",
    data,
  });
};

export const addCargoOrder = (id, data) => {
  return axios.request({
    url: `/warehouse/cargo/addCargo/${id}`,
    method: "post",
    data,
  });
};

export const getOldCargoNumber = (id) => {
  return axios.request({
    url: `/warehouse/cargo/getCargoAirwayNumber/${id}`,
    method: "get",
  });
};

export const getCargoNumber = (id) => {
  return axios.request({
    url: `/warehouse/cargo/cargoDetails/${id}`,
    method: "get",
  });
};

export const exportCargo = (data) => {
  return axios.request({
    url: `/warehouse/cargo/exportCargo`,
    method: "post",
    data,
  });
};

export const showPackage = (data) => {
  return axios.request({
    url: `/warehouse/cargo/cargoQuery`,
    method: "post",
    data,
  });
};

export const getGoodMusic = (params) => {
  return axios.request({
    url: `/warehouse/cargo/cargoGoodsNumber`,
    method: "get",
    params,
  });
};

// 删除合包
export const deletePackage = (data) => {
  return axios.request({
    url: `/warehouse/cargo/deleteAwb`,
    method: "POST",
    data,
  });
};
